import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import { ParecerReferencialPublicoDTO } from '../types';
import { mdiChevronDown, mdiChevronUp, mdiPrinter } from '@mdi/js';
import PublicoParecerReferencialService from '../service/PublicoParecerReferencialService';

interface IProps {
  parecer?: ParecerReferencialPublicoDTO;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    parecer: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check', 'download'],
  setup(__props: any) {

const props = __props as {
  parecer?: ParecerReferencialPublicoDTO;
  isSelecionado: boolean;
};





const expandido = ref(true);
const showDetalhes = ref(false);
const title = computed(() => {
  if (!props.parecer) {
    return;
  }

  const { nuParecer, nuAnoParecer, nuProcessoOficial, nuAnoProcessoOficial } =
    props.parecer;

  return `Parecer ${nuParecer}/${nuAnoParecer} - Processo ${nuProcessoOficial}/${nuAnoProcessoOficial}`;
});

const highlightedDesc = computed(() => props.parecer?.highlightedDesc || '');

watch(
  () => props.parecer,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      expandido.value = true;
      showDetalhes.value = false;
    }
  },
  { deep: true }
);

return { __sfc: true,props, expandido, showDetalhes, title, highlightedDesc, CardExpand, mdiChevronDown, mdiChevronUp, mdiPrinter, PublicoParecerReferencialService }
}

})